import React from 'react';
import { Button } from './Button';
import { AppIcon } from '../icons/AppIcon';

interface QuantitySelectorProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    className?: string;
    disabled?: boolean;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
    value,
    onChange,
    min = 0,
    max = Infinity,
    className = '',
    disabled = false
}) => {
    const handleDecrement = () => {
        if (!disabled && value > min) {
            onChange(value - 1);
        }
    };

    const handleIncrement = () => {
        if (!disabled && value < max) {
            onChange(value + 1);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            // Se o valor digitado for válido, respeita os limites se necessário,
            // ou deixa o blur tratar. Aqui vamos garantir range básico.
            if (newValue >= min && newValue <= max) {
                onChange(newValue);
            }
        }
    };

    return (
        <div className={`flex items-center gap-4 ${className}`}>
            <Button
                variant="secondary"
                size="sm"
                onClick={handleDecrement}
                disabled={disabled || value <= min}
                className="p-2 rounded-full max-md:h-12 max-md:w-12 h-10 w-10 flex items-center justify-center touch-manipulation"
                aria-label="Diminuir quantidade"
            >
                <AppIcon name="minus" className="max-md:w-5 max-md:h-5 w-5 h-5" />
            </Button>

            <input
                type="number"
                value={value}
                onChange={handleInputChange}
                min={min}
                max={max}
                disabled={disabled}
                id="subscription-user-count"
                inputMode="numeric"
                className="text-heading-md md:text-2xl font-bold w-14 max-md:h-12 md:w-20 text-center border border-subtle bg-card text-text rounded-xl md:rounded-lg shadow-sm focus:border-primary focus:ring-1 focus:ring-primary disabled:bg-surface-subtle disabled:text-muted [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
            />

            <Button
                variant="secondary"
                size="sm"
                onClick={handleIncrement}
                disabled={disabled || value >= max}
                className="p-2 rounded-full max-md:h-12 max-md:w-12 h-10 w-10 flex items-center justify-center touch-manipulation"
                aria-label="Aumentar quantidade"
            >
                <AppIcon name="plus" className="max-md:w-5 max-md:h-5 w-5 h-5" />
            </Button>
        </div>
    );
};

export default QuantitySelector;
